import { alphabet } from "./constants";

export function createAlphabet() {
  const newAlphabet: string[] = [];

  for (let i = 0; i < alphabet.length; i++) {
    for (let j = 0; j < alphabet.length; j++) {
      newAlphabet.push(alphabet[i] + alphabet[j]);
    }
  }
  return newAlphabet;
}

export function getLetterFrom(currentLetter: string, position: number) {
  const currentIndex = alphabet.indexOf(currentLetter);
  const newIndex = currentIndex + position;

  if (newIndex < 0) return alphabet[0];
  if (newIndex >= alphabet.length) return alphabet[alphabet.length - 1];

  return alphabet[newIndex];
}

export function deepCopy(data: any): any {
  return JSON.parse(JSON.stringify(data));
}



// WEBPACK FOOTER //
// ./src/modules/costPlan/assets/excelReports/ReportUtils.ts